var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("ข้อกำหนดและเงื่อนไข"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("กฎทั่วไป"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เว็บไซต์ของเราจำกัดไว้เฉพาะบุคคลที่บรรลุนิติภาวะตามที่กำหนดในเขตอำนาจศาลที่บุคคลนั้นอาศัยอยู่"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เว็บไซต์ของเราไม่รับผิดชอบต่อกฎหมายภายในประเทศ กฎหมายของรัฐบาลกลาง หรือกฎหมายระหว่างประเทศใดๆ ที่ถูกละเมิดโดยผู้ใช้ที่ใช้เว็บไซต์ของเรา"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ผู้ใช้ต้องรับผิดชอบต่อการกระทำของตนเองและผูกพันตามกฎหมายของประเทศของตน ซึ่งรวมถึงกฎหมายของรัฐหรือประเด็นทางกฎหมาย"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ตัวแทนทุกคนมีหน้าที่รับผิดชอบต่อบัญชีของสมาชิกของตน และจะต้องเคารพการเดิมพันทั้งหมดที่ได้รับการยืนยันจากพวกเขา"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ตัวแทนไม่ใช่พันธมิตรของเว็บไซต์ของเรา ดังนั้นเว็บไซต์ของเราจึงไม่รับผิดชอบต่อความแตกต่างหรือข้อพิพาทระหว่างผู้เล่นและตัวแทน"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เป็นความรับผิดชอบของผู้ใช้ในการปกป้อง ID ผู้ใช้และรหัสผ่านของตนจากการใช้งานโดยไม่ได้รับอนุญาต หาก ID ผู้ใช้และรหัสผ่านของผู้ใช้ถูกขโมยหรือถูกบุกรุก ผู้ใช้มีหน้าที่รับผิดชอบในการติดต่อตัวแทนของตนทันที จากนั้นตัวแทนจะเปลี่ยนรหัสผู้ใช้และรหัสผ่านของผู้ใช้ให้"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ในกรณีที่รหัสผู้ใช้และรหัสผ่านถูกขโมย ผู้ใช้จะต้องรับผิดชอบต่อบัญชีของตนและจะปฏิบัติตามการเดิมพันที่ได้รับการยืนยันทั้งหมดที่ส่งมา"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("กฎการเล่นเกม"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ผลลัพธ์ของเกมที่ตัดสินโดยเว็บไซต์ของเราถือเป็นที่สิ้นสุดและมีผลผูกพัน"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ในทุกกรณีของข้อพิพาท ทั้งฝ่ายบริหารเว็บไซต์ของเราและผู้เล่นจะต้องตกลงว่าฐานข้อมูลบันทึกธุรกรรมของเว็บไซต์ของเราจะทำหน้าที่เป็นผู้ตัดสินขั้นสุดท้ายในข้อพิพาท ข้อพิพาททั้งหมดจะต้องยื่นภายในวันที่ทราบผลการแข่งขัน จะไม่มีการเรียกร้องใด ๆ หลังจากวันแข่งขัน"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ผู้เล่นมีหน้าที่รับผิดชอบในการตรวจสอบความถูกต้องของธุรกรรมบัญชีทั้งหมดของตนแต่เพียงผู้เดียว"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "โปรดตรวจสอบให้แน่ใจว่าได้ตรวจสอบการเดิมพันของคุณเพื่อหาข้อผิดพลาด ข้อผิดพลาด หรือการละเว้นก่อนที่จะส่งผ่านคอมพิวเตอร์ เมื่อยอมรับการเดิมพันผ่านคอมพิวเตอร์แล้ว จะไม่สามารถเปลี่ยนแปลงหรือยกเลิกได้"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เราขอสงวนสิทธิ์ในการระงับหรือยกเลิกบัญชีของลูกค้าใดๆ ที่พบการละเมิดข้อกำหนดและเงื่อนไขเหล่านี้ มีส่วนร่วมในกิจกรรมฉ้อโกง บุกรุก โจมตี ปลอมแปลง ทำลายกฎมาตรฐาน หรือเกี่ยวข้องกับการเดิมพันแบบซินดิเคท โดยยอดคงเหลือในบัญชีทั้งหมดจะถูกระงับและถูกริบ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เราขอสงวนสิทธิ์ในการยกเลิกหรือทำให้การเดิมพันหรือบิลเดิมพันใด ๆ เป็นโมฆะ หากพบว่าเกี่ยวข้องกับการเดิมพันแบบกลุ่ม การเดิมพันที่มีการประสานงาน การสมรู้ร่วมคิด การฉ้อโกง การใช้ระบบในทางที่ผิด การแสวงหาประโยชน์จากข้อผิดพลาดทางเทคนิค อัตราต่อรองที่ไม่ถูกต้อง หรือความพยายามอื่นใดเพื่อให้ได้มาซึ่งความได้เปรียบที่ไม่เป็นธรรม เงินรางวัลที่เกี่ยวข้องอาจถูกเรียกคืน และบัญชีที่เกี่ยวข้องอาจถูกระงับหรือยกเลิก"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("ข้อจำกัดและความรับผิด"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เว็บไซต์ของเราจะไม่รับผิดชอบต่อบุคคลใด ๆ ในกรณีของการก่อวินาศกรรม เหตุสุดวิสัย และ/หรือเหตุการณ์ความล้มเหลว ความเสียหาย หรือการทำลายต่อระบบคอมพิวเตอร์กลางของเว็บไซต์ของเรา หรือบันทึก หรือส่วนใด ๆ โดยไม่กระทบต่อลักษณะทั่วไปที่กล่าวมาข้างต้น หรือความล่าช้า การสูญเสีย ข้อผิดพลาด การละเว้น หรืออื่นใดอันเป็นผลจากความล้มเหลวของโทรคมนาคมหรือระบบการส่งข้อมูลใด ๆ หรือความล่าช้าใด ๆ ที่ส่งผลให้ไม่ได้รับใบสมัครสำหรับการแข่งขันใด ๆ"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "เว็บไซต์ของเราจะไม่รับผิดชอบต่อการสูญเสียใด ๆ อันเป็นผลมาจากการกระทำของพระเจ้า ในการระบาดของสงคราม การจลาจล ความไม่สงบ การกระทำของการก่อการร้าย การกระทำของรัฐบาลหรืออำนาจ (รวมถึงการปฏิเสธหรือการเพิกถอนใบอนุญาตหรือความยินยอมใด ๆ ) การระเบิด น้ำท่วม การโจรกรรม ความเสียหายที่เป็นอันตราย การนัดหยุดงาน การล็อคเอาท์ และการดำเนินการทางอุตสาหกรรมทุกประเภท"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "ในกรณีที่การเชื่อมต่อเครือข่าย การสื่อสาร ระบบหรือข้อผิดพลาดของมนุษย์ทำให้เกิดปัญหาที่เกี่ยวข้องกับการเดิมพัน เช่น การเดิมพันสองเท่าได้รับการยอมรับ ไม่สามารถยืนยันการเดิมพันได้ วางเดิมพันหลังจากเกมเริ่ม ฯลฯ เราขอสงวนสิทธิ์ในกรณีดังกล่าว ข้อผิดพลาดเพื่อแก้ไขเป็นกรณี ๆ ไป และดำเนินการอื่น ๆ เพื่อแก้ไขข้อผิดพลาดดังกล่าว เราจะไม่มีความรับผิดใด ๆ กับคุณหรือต่อบุคคลที่สามใด ๆ ที่เกี่ยวข้องกับข้อผิดพลาดดังกล่าว หากคุณพบข้อผิดพลาดดังกล่าวและทำการเดิมพันต่อไปโดยไม่รายงานอัพไลน์ของคุณ คุณจะต้องรับผิดชอบและให้เกียรติผลการชนะ/แพ้ทั้งหมดหากข้อผิดพลาดเกิดขึ้นอีกครั้ง"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "กฎและข้อบังคับเหล่านี้ประกอบด้วยข้อตกลงทั้งหมดและความเข้าใจระหว่างทั้งสองฝ่าย"
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "หากมีความแตกต่างระหว่างเวอร์ชันภาษาอังกฤษของกฎและข้อบังคับเหล่านี้กับเวอร์ชันภาษาอื่น ๆ เวอร์ชันภาษาอังกฤษจะแทนที่ภาษาอื่นและถือว่าถูกต้องและใช้ได้"
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }